// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4267":"41114e694794acbb","9971":"bb7adabcf080b8f3"}[chunkId] + ".js";
};